import { setCookie } from '../../aaa';
import PrimaryButton from '../../components/PrimaryButton';
import { Icon } from '@iconify/react';
import closeIcon from '@iconify/icons-material-symbols/close-rounded';
import { Dialog, DialogContent } from '../../components/Dialog';
import libraryStyles from '../../SCSS/Library.module.scss';

interface Props {
  show: boolean;
  handleHideModal: () => void;
}

const HowToUseModal = ({ show, handleHideModal }: Props): JSX.Element => {
  const handleDoNotShowAgain = () => {
    setCookie('howToUseDistrictReporting', 'neverShowAgain');
    handleHideModal();
  };

  return (
    <Dialog open={show}>
      <DialogContent
        className='w-[min(92vw,78rem)] rounded-[1.6rem] border-0 bg-white px-[5rem] pb-[3rem] pt-[3rem] text-[1.6rem] shadow-[0_14px_34px_rgba(0,0,0,0.2)]'
        overlayClassName='bg-black/50'
        onEscapeKeyDown={(event) => event.preventDefault()}
        onPointerDownOutside={(event) => event.preventDefault()}
      >
        <button
          type='button'
          aria-label='Close'
          className='absolute right-[1rem] top-[1rem] flex h-[3rem] w-[3rem] items-center justify-center rounded-full border-0 bg-[#e5e5e5] p-[0.5rem]'
          onClick={handleHideModal}
        >
          <Icon className='h-[2rem] w-[2rem] cursor-pointer' icon={closeIcon} />
        </button>
        <div className='flex flex-col gap-[1rem]'>
          <h3 className="m-0 font-['GT-Walsheim-Pro-Bold'] text-[#242424]">How to Use District Reporting</h3>
          <div className='flex gap-[1rem]'>
            <div>
              <Icon className='mt-[0.3rem] h-[2rem] w-[2rem] text-[#45A8E4]' icon='prime:filter-fill' />
            </div>
            <p className='m-0'>
              <strong className="font-['GT-Walsheim-Pro-Bold']">Filtering: </strong>To display specific data on the
              graph, you can use the filter located at the top right. The following options are available for display:
              Number of Educators, Educator Logins, Student Logins, Story Opens, Lessons Access, and Time on Platform.
            </p>
          </div>
          <div className='flex gap-[1rem]'>
            <div>
              <Icon className='mt-[0.3rem] h-[2rem] w-[2rem] text-[#45A8E4]' icon='material-symbols:calendar-month' />
            </div>
            <p className='m-0'>
              <strong className="font-['GT-Walsheim-Pro-Bold']">Date Range: </strong>To view data within specific time
              frames, use the date selector located at the top left. Choose the desired time frame using the date
              selector to adjust the data displayed on the graph accordingly.
            </p>
          </div>
          <div className='flex gap-[1rem]'>
            <div>
              <Icon className='mt-[0.3rem] h-[2rem] w-[2rem] text-[#45A8E4]' icon='fa6-solid:school' />
            </div>
            <p className='m-0'>
              <strong className="font-['GT-Walsheim-Pro-Bold']">By School Reporting: </strong>View a breakdown of usage
              by all subscribed schools associated with the district.
            </p>
          </div>
        </div>
        <div className='mt-[2rem] flex flex-col items-center justify-center gap-[1rem]'>
          <PrimaryButton small onClick={handleHideModal}>
            got it
          </PrimaryButton>
          <button onClick={handleDoNotShowAgain} className={`${libraryStyles.textLink} border-0 bg-transparent`}>
            Do not show me this again
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default HowToUseModal;
